import { CONFIG } from '../../core/config';
import { BusinessEntity } from '../business-entity';
import { ModelRunMitigationColumn } from './model-run-mitigation-column';
import { Recommendation } from './recommendation';

export class Recommendations extends BusinessEntity {
  public orgTreeNodeId: string;
  public runnableModelOrgTreeNodeId: string;
  public inspectionPlanId: string;
  public modelName: string;
  public analysisName: string;
  public items: Recommendation[] = [];
  public mitigationColumns: ModelRunMitigationColumn[] = [];
  public totalRecords: number;

  public hasActivePlan: boolean;
  public isErpEnabled: boolean;

  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Recommendation';
    this.apiRoute = CONFIG.apiRoutes.recommendations;
  }

  public json(): this {
    return this;
  }

  public loadFromJson(data: Partial<Recommendations>) {
    super.loadFromJson(data);
    this.orgTreeNodeId = data.orgTreeNodeId;

    this.modelName = data.modelName;
    this.analysisName = data.analysisName;
    this.inspectionPlanId = data.inspectionPlanId;

    this.runnableModelOrgTreeNodeId = data.runnableModelOrgTreeNodeId;

    this.hasActivePlan = data.hasActivePlan;
    this.isErpEnabled = data.isErpEnabled;
    this.items = new Array<Recommendation>();
    this.totalRecords = data.totalRecords;

    if (data.items) {
      for (const rawInput of data.items) {
        const item = new Recommendation();

        item.loadFromJson(rawInput);
        this.items.push(item);
      }
    }

    if (data.mitigationColumns) {
      for (const rawMitigationColumn of data.mitigationColumns) {
        const mitigationColumn = new ModelRunMitigationColumn();

        mitigationColumn.loadFromJson(rawMitigationColumn);
        this.mitigationColumns.push(mitigationColumn);
      }
    }
  }

  get hasActive(): boolean {
    return this.hasActivePlan;
  }
}
